import React from 'react'
import { Form, Col } from 'react-bootstrap'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import { getLocaleFormLabelKey } from '../../utils/helpers'

const propTypes = {
  fieldConfig: PropTypes.object.isRequired
}

const AddressPostalCodeControl = ({
  formik,
  fieldConfig,
  canEdit,
  alignCenter = true,
  columnSize = 5
}) => {
  const { t } = useTranslation('common')
  let localizedFormLabel = ''
  if (fieldConfig?.label) {
    localizedFormLabel = t(getLocaleFormLabelKey(fieldConfig.label))
  }
  return (
    <Form.Group
      as={Col}
      md={columnSize}
      controlId="formPostalCode"
      className={alignCenter ? 'mx-auto' : ''}
    >
      <Form.Label>
        {localizedFormLabel}
        {!fieldConfig?.required ? <span className="form-optional">({t('Optional')})</span> : null}
      </Form.Label>
      <Form.Control
        type="text"
        name="zipCode"
        value={formik.values.zipCode}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        placeholder=""
        isInvalid={!!formik.errors.zipCode}
        maxLength={10}
        readOnly={!canEdit}
        required={fieldConfig?.required}
      />
      <Form.Control.Feedback type="invalid">{formik.errors.zipCode}</Form.Control.Feedback>
    </Form.Group>
  )
}

AddressPostalCodeControl.propTypes = propTypes

export default connect(AddressPostalCodeControl)
